module.exports = __webpack_public_path__ + "img/nav-right.71372063.png";